import { Divider, DividerProps } from '@mui/material'

export type MolsonDividerProps = {
  dataTestId?: string
} & DividerProps

export const MolsonDivider = ({
  dataTestId,
  children,
  ...props
}: MolsonDividerProps) => {
  return (
    <Divider data-testid={dataTestId} {...props}>
      {children}
    </Divider>
  )
}
